import { Box } from "@mui/material";
import React from "react";

const CharsleftDisplay = ({ value, maxLength, threshold }) => {
  if (value.length < threshold) {
    return null;
  }
  const interp = (value.length - threshold) / (maxLength - threshold);
  return (
    <Box
      sx={{
        color: `rgba(255, 0, 0, ${0.4 + interp * 0.6})`,
      }}>
      {maxLength - value.length} characters left
    </Box>
  );
};

export default CharsleftDisplay;
